import { createRouter, createWebHistory } from 'vue-router'
// import Home from '../views/Home.vue'
// import ArticleList from '../views/ArticleList.vue'
const routes = [
  {
    path: '/',
    name: 'Home1',
    component: () => import(/* webpackChunkName: "articlelist" */ '@/views/ArticleList.vue'),
    meta: {
      tittle: 'Namaste Nepal ',
      icon: '/assets/bilder/namaste_nepal_logo.png'
    }
  },
  {
    path: '/:slug',
    name: 'Home2',
    component: () => import(/* webpackChunkName: "articlelist" */ '@/views/ArticleList.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    // params: { slug: 'checkout' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/checkout.vue')
  },
  // {
  //   path: '/:slug',
  //   name: 'paypal',
  //   params: { slug: 'paypal' },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "paypal" */ '@/views/Paypal.vue')
  // },
  {
    path: '/thankyou',
    name: 'Thankyou',
    // params: { slug: 'thankyou' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thankyou" */ '@/views/Thankyou.vue')
    // meta: {
    //   tittle: 'Namaste Nepal ',
    //   icon: '@/assets/bilder/namaste_nepal_logo.png'
    // }
  },
  {
    path: '/:pathMatch(.*)*',
    alias: '/:pathMatch(.*)*',
    name: 'notFountd',
    component: () => import(/** WebpackchunkName: NotFound  */ '@/views/NotFound.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory('/store/current/dist/'),
  history: createWebHistory('/nnc/store/'),
  // history: createWebHistory('/namastenepal/httpd.www/store/current/dist/'),
  linkExactActiveClass: 'Namaste-Food-Category',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
        if (document.querySelector(to.hash)) {
          return position
        }
        return false
      }
    }
  },
  routes
})

export default router
